import axios from 'axios';
import { AuthResponse } from 'msal';
import { msalAuth, msalConfig } from '../auth/MsalAuthProvider';

export const axioClient = axios.create();

// Add a request interceptor
axioClient.interceptors.request.use(
  async (config) => {
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json-patch+json';
    }

    const accessTokenRequest = {
      scopes: [`api://${msalConfig.clientId}/user_impersonation`],
    };
    let authResponse: AuthResponse = null;
    try {
      authResponse = await msalAuth.acquireTokenSilent(accessTokenRequest);
    } catch (error) {
      console.log('Silent token acquisition failed, redirecting for API consent', error);
      msalAuth.acquireTokenRedirect(accessTokenRequest);
      return Promise.reject(error); // stop this request; redirect will restart the flow
    }

    const accessToken = authResponse?.accessToken;
    if (!accessToken) {
      // Never fall back to the id_token — MISE rejects it and it's not a valid API credential
      console.log('No access token returned, forcing interactive API token acquisition');
      msalAuth.acquireTokenRedirect(accessTokenRequest);
      return Promise.reject(new Error('No access token available'));
    }

    config.headers['Authorization'] = `Bearer ${accessToken}`;
    return config;
  },
  (error) => {
    console.log('Error in axios interceptors');
    return Promise.reject(error);
  }
);
